import React from "react";
import "./CommonNudge.css";

const CommonNudge = ({
  title,
  description,
  actionLabel,
  onAction,
  onClose,
  disabled = false,
  ariaLabel = "Notification",
  dockToBottom = false,
}) => (
  <aside
    className={`common-nudge ${dockToBottom ? "common-nudge--bottom" : ""}`}
    aria-label={ariaLabel}
  >
    <button
      type="button"
      className="common-nudge__close"
      aria-label="Close notification"
      onClick={onClose}
    >
      ×
    </button>

    {title && <h3 className="common-nudge__title">{title}</h3>}
    {description && (
      <p className="common-nudge__description">{description}</p>
    )}

    {actionLabel && (
      <button
        type="button"
        className="common-nudge__action action-tab"
        disabled={disabled}
        onClick={onAction}
      >
        {actionLabel}
      </button>
    )}
  </aside>
);

export default CommonNudge;
